import EventBus from '@ustra/nuxt/src/vue/event-bus'

export interface PushSettingEventState {
  type: string
}

export class PushSettingEventBus extends EventBus<PushSettingEventState> {
  public name(): string {
    return 'pushSettingEventBus'
  }
}

export default new PushSettingEventBus()
